import React, { useRef, Component } from "react";
import { useHistory } from "react-router-dom";

const Header = (props) => {
  const history = useHistory();

  const searchTextRef = useRef();

  const handleSearch = () => {
    let searchText = searchTextRef.current.value;

    searchText = searchText ? searchText.replace(/ /g, "") : null;

    if (!searchText) {
      return;
    }

    history.push("/admin/quick_search/" + searchText);
    // window.location.reload();
  };

  const enterKye = (e) => {
    if (e.key === "Enter") {
      let searchText = searchTextRef.current.value;

      searchText = searchText ? searchText.replace(/ /g, "") : null;

      if (!searchText) {
        return;
      }
      history.push("/admin/quick_search/" + searchText);
      // window.location.reload();
    }
  };

  return (
    <div>
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        <>
          {/* Left navbar links */}
          <ul className="navbar-nav">
            <li className="nav-item">
              <a
                className="nav-link"
                data-widget="pushmenu"
                href="#"
                role="button"
              >
                <i className="fas fa-bars" />
              </a>
            </li>
            {/* <li className="nav-item d-none d-sm-inline-block">
                <a href="index3.html" className="nav-link">
                  Home
                </a>
              </li>
              <li className="nav-item d-none d-sm-inline-block">
                <a href="#" className="nav-link">
                  Contact
                </a>
              </li> */}
          </ul>
          {/* Right navbar links */}
          <ul className="navbar-nav ml-auto pr-4">
            {/* Navbar Search */}
            <li className="nav-item">
              <div className="navbar-search-block">
                <form className="form-inline">
                  <div className="input-group input-group-sm">
                    <input
                      className="form-control form-control-navbar"
                      type="search"
                      placeholder="Search"
                      aria-label="Search"
                      ref={searchTextRef}
                      onKeyPress={enterKye}
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-navbar"
                        type="button"
                        onClick={() => {
                          handleSearch();
                        }}
                      >
                        <i className="fas fa-search" />
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </li>
          </ul>
        </>
      </nav>
    </div>
  );
};

export default Header;
